// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * This file is to only contain styles which are specific to the CG
 * application. Anything overriding Online Style Guide styles should
 * go in mixins.less.
 */
`, "",{"version":3,"sources":["webpack://./components/app.less"],"names":[],"mappings":"AAAA;;;;EAIE","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
